module.exports = __webpack_public_path__ + "static/img/xiaqiyugao.31b84bbe.png";